import React, {PureComponent} from "react";
import withStyles from '@mui/styles/withStyles';
import Button from "@mui/material/Button";
import ShareIcon from "@mui/icons-material/Share";
import Snackbar from "@mui/material/Snackbar";
import CircularProgress from "@mui/material/CircularProgress";
import moment from "moment";
import {UrlBuilder} from "../../../core/url/UrlBuilder";

const useStyles = theme => ({
    button: {
        minWidth: '30px',
        width: '30px',
        height: '30px',
        padding: '0',
    },
});

class ShareWorkoutButton extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            snackbarMessage: null,
        };
    }

    handleShare = async () => {
        this.setState({isLoading: true});

        try {
            const response = await fetch(UrlBuilder.workout.shareWorkoutApi(this.props.workout.id), {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
            });

            const result = await response.json();
            const token = result.data.token;
            const shareUrl = window.location.origin + UrlBuilder.workout.sharedWorkoutPage(token);

            const workout = this.props.workout;
            const workoutName = workout.name || 'Workout';
            const date = moment(workout.dateTimeStarted).format('ddd, MMM D');

            let exerciseCount = 0;
            workout.routines?.forEach(r => { exerciseCount += r.exercises?.length || 0; });

            const parts = [`${workoutName} — ${date}`];
            if (exerciseCount > 0) parts.push(`${exerciseCount} exercise${exerciseCount !== 1 ? 's' : ''}`);
            if (workout.totalVolume > 0) parts.push(`${Number(workout.totalVolume).toLocaleString()} volume`);

            const shareData = {
                title: `${workoutName} — My Work in Progress`,
                text: `Check out my ${workoutName} workout! ${parts.join(' · ')}\n\nTracked with My Work in Progress`,
                url: shareUrl,
            };

            if (navigator.share && this.isMobileOrPWA()) {
                try {
                    await navigator.share(shareData);
                    this.setState({isLoading: false});
                    return;
                } catch (err) {
                    if (err.name === 'AbortError') {
                        this.setState({isLoading: false});
                        return;
                    }
                }
            }

            await navigator.clipboard.writeText(shareUrl);
            this.setState({
                snackbarMessage: 'Share link copied to clipboard!',
                isLoading: false,
            });
        } catch (err) {
            this.setState({
                snackbarMessage: 'Failed to create share link.',
                isLoading: false,
            });
        }
    }

    isMobileOrPWA = () => {
        const isStandalone = window.matchMedia('(display-mode: standalone)').matches
            || window.navigator.standalone === true;
        const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
        return isStandalone || isMobile;
    }

    render() {
        const {classes} = this.props;

        return <>
            <Button
                variant="contained"
                onClick={this.handleShare}
                size="small"
                className={classes.button}
                sx={{minWidth: 32, height: 28, p: 0.5}}
                disabled={this.state.isLoading}
            >
                {this.state.isLoading
                    ? <CircularProgress size={16} color="inherit"/>
                    : <ShareIcon fontSize="small"/>
                }
            </Button>

            <Snackbar
                open={Boolean(this.state.snackbarMessage)}
                autoHideDuration={3000}
                onClose={() => this.setState({snackbarMessage: null})}
                message={this.state.snackbarMessage}
            />
        </>;
    }
}

export default withStyles(useStyles)(ShareWorkoutButton);
